import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DictionaryEntryModel, DictionaryKey, HxDictionaryService } from 'hx-services';
import { formatISO, parseISO } from 'date-fns';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { NzFormControlComponent, NzFormDirective, NzFormItemComponent, NzFormLabelComponent } from 'ng-zorro-antd/form';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { NzInputDirective } from 'ng-zorro-antd/input';
import { NzRadioComponent, NzRadioGroupComponent } from 'ng-zorro-antd/radio';
import { NzOptionComponent, NzSelectComponent } from 'ng-zorro-antd/select';
import { NzDatePickerComponent } from 'ng-zorro-antd/date-picker';
import { HxUserSelectComponent } from 'hx-components';
import { NgFor } from '@angular/common';


@Component({
    selector: 'hc-store-info-form',
    templateUrl: './store-info-form.component.html',
    styleUrls: ['./store-info-form.component.less'],
  imports: [TranslocoDirective, FormsModule, NzFormDirective, ReactiveFormsModule, NzRowDirective, NzColDirective, NzFormItemComponent, NzFormLabelComponent, NzFormControlComponent, NzInputDirective, NzRadioGroupComponent, NzRadioComponent, NzSelectComponent, NzOptionComponent, NzDatePickerComponent, HxUserSelectComponent, NgFor, TranslocoPipe]
})
export class StoreInfoFormComponent implements OnChanges, OnInit, OnDestroy {
  @Input() formInfo?: string | null;
  @Output() formInfoChange = new EventEmitter<string>();

  referrers: DictionaryEntryModel[] = [];
  formStoreInfo = new FormGroup({
    ext_1C_code: new FormControl<string | null>(null),
    onlineBeforeCloseLimit: new FormControl<number | null>(null),
    signUserId: new FormControl<number | null>(null),
    switchDate: new FormControl<Date | null>(null),
    onlinePaymentRequired: new FormControl<boolean | null>(null),
    curbsidePickupEnabled: new FormControl<boolean | null>(null),
    curbsidePickupRadius: new FormControl<number | null>(null),
    dgisUrl: new FormControl<string | null>(null),
    yandexUrl: new FormControl<string | null>(null),
    mapType: new FormControl<string | null>(null),
    googlePlaceId: new FormControl<string | null>(null),
    googlePlaceType: new FormControl<string | null>(null),
    referrers: new FormControl<string | null>(null),
    locationHint: new FormControl<string | null>(null),
  });
  private $destroyed = new Subject<void>();

  constructor(
    private dictionary: HxDictionaryService,
  ) {
  }

  async ngOnInit() {
    this.dictionary.getEntries({key: DictionaryKey.utmReferrer}).then((list) => {
      this.referrers = list;
    });
    this.formStoreInfo.valueChanges.pipe(takeUntil(this.$destroyed)).subscribe(a => {
      if (this.formStoreInfo.valid) {
        const obj: any = Object.fromEntries(Object.entries(a).filter(([_, v]) => v != null && v != ''));
        if (obj.switchDate) {
          obj.switchDate = formatISO((obj.switchDate as Date), {representation: 'date'});
        }
        this.formInfoChange.emit(JSON.stringify(obj));
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['formInfo']?.currentValue) {
      const json = JSON.parse(changes['formInfo'].currentValue);
      if (json.switchDate) {
        json.switchDate = parseISO(json.switchDate);
      }
      this.formStoreInfo.patchValue(json);
    }
  }

  ngOnDestroy(): void {
    this.$destroyed.next();
    this.$destroyed.complete();
  }

}
